export enum Authority{
    ROLE_NAME ="mdh-staff",
    NOT_USED_CURRENTLY = "not-used-currently"
}